import $ from 'jquery';

var pushed = {};
var STORAGE_KEY = 'gf_submit_form_id';

function getFormId($form) {
	var dataId = $form.data('formid');
	if (dataId) {
		return parseInt(dataId, 10);
	}

	var match = ($form.attr('id') || '').match(/^gform_(\d+)$/);
	return match ? parseInt(match[1], 10) : null;
}

function stashSubmit(formId) {
	try {
		sessionStorage.setItem(STORAGE_KEY, String(formId));
	} catch (e) {}
}

function readStash() {
	try {
		return parseInt(sessionStorage.getItem(STORAGE_KEY), 10) || null;
	} catch (e) {
		return null;
	}
}

function clearStash() {
	try {
		sessionStorage.removeItem(STORAGE_KEY);
	} catch (e) {}
}

function pushFormSubmit(formId) {
	if (!formId || pushed[formId]) {
		return;
	}
	pushed[formId] = true;
	clearStash();

	window.dataLayer = window.dataLayer || [];
	dataLayer.push({
		event: 'g_form_submit',
		form_submission: 'valid',
		formId: formId
	});
}

$(document).off('gform_confirmation_loaded.gfDL');
$(document).on('gform_confirmation_loaded.gfDL', function(event, formId) {
	pushFormSubmit(formId);
});

$(document).on('submit', 'form[id^="gform_"]', function() {
	var formId = getFormId($(this));
	if (formId) {
		stashSubmit(formId);
	}
});

$(function() {
	if ($('.gform_validation_error').length) {
		clearStash();
		return;
	}

	$('[id^="gform_confirmation_wrapper_"]').each(function() {
		var match = (this.id || '').match(/^gform_confirmation_wrapper_(\d+)$/);
		if (match) {
			pushFormSubmit(parseInt(match[1], 10));
		}
	});

	var stashed = readStash();
	if (stashed) {
		pushFormSubmit(stashed);
	}
});

$('.quiz_start_page .gform_next_button').on('click', function (e) {

		var hcp_provider = $('input[name="input_1"]:checked').val();

		window.dataLayer = window.dataLayer || [];
		dataLayer.push({
			'event': 'start_energy_quiz',
			'quiz_type': hcp_provider
		});

	});

$(document).on('gform_page_loaded', function(event, form_id, current_page){
	$('.quiz_start_page .gform_next_button').on('click', function (e) {

		var hcp_provider = $('input[name="input_1"]:checked').val();

		window.dataLayer = window.dataLayer || [];
		dataLayer.push({
			'event': 'start_energy_quiz',
			'quiz_type': hcp_provider
		});

	});
});
